import client from '../httpClient';

const responseUpdateMediumApi = (pathParameter, params) => {
  return client.put(`/response-types/${pathParameter}`, JSON.stringify(params));
};

export default responseUpdateMediumApi;
